// ═══════════════════════════════════════════════════════════════════════════════
// DISTINGUIR «no te corresponde» DE «algo se rompió» (COL.12)
//
// 🔴 Los dos son un error de red desde el punto de vista del `catch`, y hasta este bloque
//    las pantallas los pintaban igual: «No se pudo cargar…». Se arreglan de forma
//    distinta —uno pidiendo un permiso, el otro reintentando o avisando a soporte— así
//    que confundirlos manda a la persona al sitio equivocado.
//
// 🔴 Se ramifica por `code` TOP-LEVEL, NUNCA por el texto del mensaje: el texto viene en
//    el idioma del servidor y cambia sin avisar (DT.60). El backend manda
//    `{detail, code, capacidad}` con 403 desde COL.9 y esa forma ya está verificada
//    contra producción.
//
// ⚠️ El 401 NO entra aquí, y no es un olvido: lo atrapa antes el interceptor de
//    `lib/api.js`, que limpia la sesión y manda a /login. «Tu sesión caducó» se arregla
//    entrando otra vez; «no tienes el permiso» no. Ya estaban separados y siguen
//    separados.
// ═══════════════════════════════════════════════════════════════════════════════

const CODIGOS_DE_ACCESO = new Set([
  "CAPACIDAD_REQUERIDA", // te falta la capacidad que exige el endpoint
  "PERTENENCIA_REVOCADA", // te sacaron de la clínica
  "DEMO_SIN_REPORTES", // la demo pública no ve el módulo financiero
]);

/** ¿Este error es «no te corresponde» y no «se rompió algo»?
 *
 *  Devuelve `{code, capacidad, detail}` cuando lo es, y `null` cuando no — para que la
 *  pantalla ramifique con un `if` y no tenga que mirar dentro de la respuesta. */
export function faltaDeAcceso(e) {
  const r = e?.response;
  if (!r || r.status !== 403) return null;
  const d = r.data || {};
  if (!CODIGOS_DE_ACCESO.has(d.code)) return null;
  return { code: d.code, capacidad: d.capacidad || null, detail: d.detail || null };
}
